import React, { useState, useEffect } from "react";
import Sidebar from "../Navigation/Sidebar/Sidebar";
import vmImage from "../../assests/vmImage.png";
import "./style.css";

const Home = () => {
  const [userData, setUserData] = useState(null);
  const [greeting, setGreeting] = useState("");
  const [currentTime, setCurrentTime] = useState("");

  useEffect(() => {
    try {
      const data = localStorage.getItem("data");
      if (data) {
        const parsed = JSON.parse(data);
        setUserData(parsed);
      }
    } catch (error) {
      console.error("Error loading user data:", error);
    }
  }, []);

  // Update greeting based on time
  useEffect(() => {
    const updateGreeting = () => {
      const now = new Date();
      const hours = now.getHours();
      
      // Format current time
      const timeStr = now.toLocaleTimeString('en-US', { 
        hour: '2-digit', 
        minute: '2-digit',
        hour12: true 
      });
      setCurrentTime(timeStr);

      // Determine greeting based on hour
      let greetingText = "";
      let emoji = "";
      
      if (hours >= 5 && hours < 12) {
        greetingText = "Good Morning";
        emoji = "🌅";
      } else if (hours >= 12 && hours < 17) {
        greetingText = "Good Afternoon";
        emoji = "☀️";
      } else if (hours >= 17 && hours < 21) {
        greetingText = "Good Evening";
        emoji = "🌇";
      } else if (hours >= 21 && hours < 24) {
        greetingText = "Good Night";
        emoji = "🌙";
      } else {
        greetingText = "Good Night";
        emoji = "🌙";
      }
      
      setGreeting(`${emoji} ${greetingText}`);
    };

    updateGreeting();
    
    // Update greeting every minute
    const interval = setInterval(updateGreeting, 60000);
    
    return () => clearInterval(interval);
  }, []);

  const userName = userData?.details?.userDetails?.full_name || "User";

  return (
    <div className="ds-home-layout">
      {/* Sidebar */}
      <Sidebar />
      
      {/* Main Content */}
      <div className="ds-home-main">
        <div className="ds-home-container">
          <div className="ds-home-content-wrapper">
            {/* Left Side - Text Content */}
            <div className="ds-home-text-section">
            
              
              {/* Greeting */}
              <h1 className="ds-home-greeting">
                {greeting}!
              </h1>
              
              <h2 className="ds-home-title">
                Welcome to  
                <span className="ds-home-highlight"> Daalchini</span>
              </h2>
              <p className="ds-home-subtitle">
                Hello, <span className="ds-user-name">{userName}</span>! 
                We're glad to have you here.
              </p>
            </div>

            {/* Right Side - Vending Machine Image */}
            <div className="ds-home-image-section">
              <div className="ds-home-image-wrapper">
                <img 
                  src={vmImage}
                  alt="Vending Machine" 
                  className="ds-home-image"
                />
                <div className="ds-home-image-glow"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Home;